/* Speed optimization for the unpublished "Mejorar VELOCIDAD" theme.
   Reveal-on-scroll effects are intentionally neutralized to avoid observers,
   scroll handlers and non-composited animations during initial rendering. */
(function () {
  var style = document.createElement('style');
  style.textContent = '@media (prefers-reduced-motion: no-preference){.scroll-trigger.animate--fade-in,.scroll-trigger.animate--slide-in{opacity:1!important;transform:none!important;animation:none!important;transition:none!important}.animate--zoom-in>img,.animate--zoom-in>svg{scale:1!important;transition:none!important}}';
  document.head.appendChild(style);
})();
